$(function(){
    $('.js-brands-top-anchor').on('click', function() {
        slideTo($('.js-brands-top'), 40, 400);
    });

    $('.js-brands-anchor').on('click', function() {
        slideTo($($(this).data('anchor')), 20, 400);
    });

    $('.js-brands-menu').on('click', function() {
        const $nav = $('.js-brands-nav');

        $nav.slideToggle(250);
    });
});
